import { render, staticRenderFns } from "./LatestIngestionEventsWidget.vue?vue&type=template&id=c396c9d2"
import script from "./LatestIngestionEventsWidget.vue?vue&type=script&lang=js"
export * from "./LatestIngestionEventsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports